module.exports = __webpack_public_path__ + "assets/img4.5b978a43.jpg";